import Layout from "../../components/Layout.js";
import Header from "../../components/Header";
import Global from "../../components/Constants";
import Images from "../../common/Images";
import Collections from "@/components/home/MarketplaceIce/collections/index.js";

//CHANGO COLLECTIONS

const Marketplace = () => {
  return (
    <Layout>
      <Header
        title={Global.CONSTANTS.TITLE + " | Marketplace"}
        description={Global.CONSTANTS.DESCRIPTION}
        image={Images.SOCIAL_SHARE}
      />

      <Collections />
    </Layout>
  );
};

export default Marketplace;
